import React, {useState} from "react";
import {ReactComponent as CloseIcon} from "../../../../../assets/images/adModal/icon-close.svg";
import {ReactComponent as LogoIcon} from '../../../../../assets/images/white-logo.svg'

export const PopupAdModal = (props) => {
  const [email, setEmail] = useState('')
  const [companyWebsite, setCompanyWebsite] = useState('')
  const {error, title, description, subscribing, button_text, imageUrl, onClose, show, onSubmit} = props

  const onEmailChange = (e) => {
    e.preventDefault()
    setEmail(e.target.value)
  }

  const onBackgroundClick = (e) => {
    if (window.matchMedia('(min-width: 751px)').matches) return
    onClose(e)
  }

  return <>
    {show && <div className="modal-subscription-popup-background" onClick={onBackgroundClick} />}

    <form
      className={`modal-subscription-popup ${show ? ' modal-subscription-show' : ''} ${imageUrl ? 'with-image' : ''}`}
      onSubmit={e => onSubmit(e, email, companyWebsite)}>
      <div aria-hidden="true" style={{position: 'absolute', left: '-10000px', width: 1, height: 1, overflow: 'hidden'}}><label>Leave this field empty<input name="company_website" tabIndex={-1} autoComplete="off" value={companyWebsite} onChange={e => setCompanyWebsite(e.target.value)}/></label></div>
      <div className="modal-subscription-inner">
        <div className="modal-subscription-image">
          {onClose && <button type="button" className="modal-subscription-close" aria-label="Close discount offer" onClick={onClose}>
            <CloseIcon/>
          </button>}

          <img src={imageUrl}/>
        </div>

        <div className="modal-subscription-content">
          {onClose && <button type="button" className="modal-subscription-close" aria-label="Close discount offer" onClick={onClose}>
            <CloseIcon/>
          </button>}

          <div className="modal-subscription-logo">
            <LogoIcon />
          </div>

          <div className="modal-subscription-title">
            {title}
          </div>

          {description && <div className="modal-subscription-description editorContent"
                               dangerouslySetInnerHTML={{__html: description}}/>}

          <div className="modal-subscription-email-and-button">
            <div className="modal-subscription-email">
              <label for="email">Email</label>
              <input value={email} onChange={onEmailChange} type="email" placeholder="Email Address"/>
              {error && <div className="formInputError" role="alert">{error}</div>}
            </div>

            <div className="modal-subscription-buttons">
              <button className="projectEditButton" type="submit" disabled={subscribing}>
                {button_text}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </>
}
